<template>

    <div class="stepper-box bg-white p-3 d-flex flex-column justify-content-between h-100">
        <div class="container">

            <ul class="d-none d-md-flex bg-light nav nav-pills nav-justified pad-md">
                <li class="nav-item" role="header-stepper" v-for="(step, index) in steps" :key="index">
                    <!--<button class="nav-link d-flex justify-content-center flex-column" :class="[index === currentStep.index ? 'active' : '']" type="button" role="step" @click="navSteps(index)" >-->
                    <div class="nav-link d-flex justify-content-center flex-column" :class="[index === currentStep.index ? 'active' : '']" role="step">
                        <span class="bullet d-flex justify-content-center align-items-center align-self-center">
                            <i class="fas fa-check" v-if="index < currentStep.index || currentStep.index === steps.length - 1"></i>
                            <div v-else>{{index}}</div>
                        </span>
                        <span class="align-self-center">
                            {{step.title}}
                        </span>
                    </div>
                    <!--</button>-->
                </li>
            </ul>
        </div>
        <template>
            <div class="tab-content" v-bind:class="classContent" :style="border">
                <form class="row justify-content-center" action="" ref="formStepper">
                    <div class="content col-md-8 tab-pane" v-bind:class="steps[currentStep.index].class">
                        <transition-group name="fade" mode="out-in" tag="div">
                            <div class="mb-3" v-for="[key, field] of Object.entries(steps[currentStep.index].fields)" :key="key">
                                <component
                                  @input="handleInputValue($event, key)"
                                  :is="'tic' + field.component.charAt(0).toUpperCase() + field.component.slice(1)"
                                  :name="field.hasOwnProperty('name') ? field.name : key"
                                  :required="field.hasOwnProperty('required') ? field.required : false"
                                  :custom-input="false"
                                  :label="field.hasOwnProperty('label') ? field.label : 'formation.offline.'+key+'.label'"
                                  :placeholder="field.hasOwnProperty('placeholder') ? field.placeholder : $te('formation.offline.'+key+'.placeholder') ? 'formation.offline.'+key+'.placeholder' : ''"
                                  v-bind="field.params"
                                  :value="fieldsValues[currentStep.index][key]"
                                  :state="errors.hasOwnProperty(currentStep.index) && errors[currentStep.index].hasOwnProperty(key) ? false : null"
                                >
                                </component>
                                <div v-if="errors.hasOwnProperty(currentStep.index) && errors[currentStep.index].hasOwnProperty(key)">
                                  <span v-for="error in errors[currentStep.index][key]" class="text-danger">
                                    {{ $t('error.' + error) }}
                                  </span>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </form>
            </div>
        </template>
        <template>
            <div class="footer d-flex justify-content-between">
                <div class="bottom bg-light p-3" v-if="currentStep.index > 0" @click="prevStep()">
                    <span class="mr-2">
                        <i class="fas fa-chevron-left" aria-hidden="true"></i>
                    </span>
                    <span class="">Précédent</span>
                </div>
                <div v-if="currentStep.index == steps.length -1" class="bottom ml-auto bg-light p-4" @click="submitForm()">
                    <span>Envoyer</span>
                </div>
                <div v-else class="bottom ml-auto bg-light p-3" @click="nextStep()">
                    <span>Suivant</span>
                    <span class="ml-2">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import ticTextInfo from '@/components/formation/offline/textInfo'
import ticText from '@/components/frontoffice/form/baseInput/text'
import ticSelect from '@/components/frontoffice/form/baseInput/selectBVue'
import ticCheckboxGroup from '@/components/frontoffice/form/baseInput/checkboxBVue'
import ticRadio from '@/components/frontoffice/form/baseInput/radioBVue'
import ticSingleRadio from '@/components/frontoffice/form/baseInput/singleRadioBVue'
import ticNumber from '@/components/frontoffice/form/baseInput/number'
import ticDateRange from '@/components/frontoffice/form/baseInput/dateRange'

import ticRooms from '@/components/formation/form/offline/rooms'
import ticPaymentMethod from '@/components/formation/form/offline/paymentMethod'

export default {
  components: {
    ticTextInfo,
    ticText,
    ticSelect,
    ticCheckboxGroup,
    ticRadio,
    ticSingleRadio,
    ticNumber,
    ticDateRange,
    ticRooms,
    ticPaymentMethod
  },
  props: {
    steps: {
      type: Array
    },
    classContent: {
      type: Object
    },
    primaryColor: {
      type: String,
      default: '#26318d'
    },
    secondaryColor: {
      type: String,
      default: '#E65011'
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    borderStyle: {
      type: String,
      default: 'solid'
    },
    borderWidth: {
      type: String,
      default: '0px'
    },
    borderColor: {
      type: String,
      default: function () {
        return this.primaryColor
      }
    },
    border: {
      type: Object,
      default: function () {
        return {
          'border-color': this.borderColor,
          'border-radius': this.borderRadius,
          'border-style': this.borderStyle,
          'border-width': this.borderWidth
        }
      }
    }
  },
  data () {
    return {
      currentStep: {},
      primary: 'red',
      secondary: '10px',
      fieldsValues: [],
      errors: []
    }
  },
  methods: {
    activateStep (index) {
      if (this.steps[index]) {
        this.currentStep = {
          index: index
        }
      }
    },
    nextStep () {
      if (this.$refs.formStepper.reportValidity()) {
        let currentIndex = this.currentStep.index + 1
        this.activateStep(currentIndex)
      }
    },
    prevStep () {
      let currentIndex = this.currentStep.index - 1
      this.activateStep(currentIndex)
    },
    navSteps (index) {
      if (this.$refs.formStepper.reportValidity()) {
        this.activateStep(index)
      }
    },
    handleInputValue (value, id) {
      this.fieldsValues[this.currentStep.index][id] = value
    },
    submitForm () {
      this.errors = []
      if (this.$refs.formStepper.reportValidity()) {
        this.$emit('submit', this.fieldsValues)
      }
      // this.$emit('submit', this.fieldsValues)
    },
    dealFailure (errors) {
      this.errors = errors
      this.activateStep(parseInt(Object.keys(errors)[0]))
    }
  },
  created () {
    this.activateStep(0)
    for (let index = 0; index < this.steps.length; index++) {
      let tmp = {}
      for (let nameField in this.steps[index].fields) {
        let field = this.steps[index].fields[nameField]
        if (!field.hasOwnProperty('dontSave')) {
          let value = ''
          // Cas des default
          if (field.hasOwnProperty('default')) {
            value = field.default
          }
          // Cas des dateRange
          if (field.component === 'dateRange') {
            value = {}
            value['from'] = new Date()
            value['to'] = new Date() + 1
          }
          tmp[nameField] = value
        }
      }
      this.fieldsValues.push(tmp)
    }
  }

}
</script>

<style lang="scss" scoped>
@media (min-width: 810px) {
    .tab-content{

        overflow: scroll;
        overflow-x: hidden;
   }
}
.label{
    color: grey !important;
}
.bottom:hover{
    cursor: pointer;
}
.bottom{
    color: #e65011;
}
.nav .nav-link{
    display: flex;
}
.nav-pills .nav-link{
    border: 0;
    border-radius: 0.25rem;
    background: 0 0;
}
.nav .nav-link:not(.active){
    color: #1a2050;
}
.nav .nav-link.active{
    background-color: #fff;
    color: #e65011;
    width:100%;
}
.pad-md{
    padding: 1rem;
}
.pad-2{
    padding: 2%;
}

.bullet{
    position: relative;
    border: 1px solid #e65011;
    width: 30px;
    height: 30px;
    border-radius: 100%;
}
.title{
    font-size: small;
    color: #26318d;
    text-align: center;
    margin-top: 0.3rem;
}
.content{
    overflow: hidden;
}
.step{
    position: relative;
}
.header{

}
.footer{
    display: flex;
    padding-top: 1%;
}
.line{
    width:100%;
    height: 2px;
    position: absolute;
    z-index: -1;
    top:25%;
    left:50%;
}
.step:hover{
    background-color: #dbdbdb;
    //cursor: pointer;
}

 .fade-leave-active, .fade-enter-active  {
  transition: opacity .15s linear;
}

.fade-enter, .fade-leave-to{
  opacity: 0;
}

</style>
